module.exports = __webpack_public_path__ + "static/media/logo_squicker_fond.a0372463.png";